export enum Role {
  ORGANIZATION_ADMIN = "organization_admin",
  ORGANIZATION_SUPER_ADMIN = "organization_superadmin",
  USER = "user",
  ADMIN = "admin",
  SUPERADMIN = "superadmin",
}
